import React from 'react';
import { useSelector } from 'react-redux';

const EventsSection = ({ events, nextEvents }) => {

  const notices = useSelector((state) => state.auth.notices);
  return (

    <div className="" style={{ paddingTop: "50px" ,marginLeft:"10px"}}>



      <div className=" col-xs-20">
        <div className="prestige-post new-uiuhgt">
          <h4>Notice Board <span>------------</span></h4>
          <marquee behavior="scroll" direction="up" height="312" scrolldelay="100" scrollamount="2">

            <ul className="posts">
              {notices
                .filter(n => n.typeof === 1)
                .map((nextEvent, index) => (
                  <li className="post" key={index}>
                    <h3 className="entry-title">
                      <a href={nextEvent.popup_link}>{nextEvent.popup_message}</a>
                    </h3>
                    <span className="date">
                      <i className="fa fa-calendar" aria-hidden="true"></i> {nextEvent.created_at}
                    </span>
                    <span className="location"><i className="fa fa-map-marker" aria-hidden="true"></i></span>
                  </li>
                ))}
            </ul>
          </marquee>
        </div>
      </div>



    </div>
  );
};

export default EventsSection;
